// extracted by mini-css-extract-plugin
export default {"container3D":"DisplayVehicles_container3D__SdXIV","table":"DisplayVehicles_table__hteAr","cont":"DisplayVehicles_cont__tGlXI"};